import { client } from '@src/apollo/client';
import { GOALS, USER_DETAILS } from '@src/queries/user';
import { IHealthGoalsQueryResponse, IUserDetailsQueryResponse } from '@src/types/query-response';
import { buildShopifyCheckoutAttributes } from '@src/utils/shopify-checkout-attributes';

export const useShopifyCheckoutAttributes = (isFreeTrial: boolean) => {
  const getShopifyCheckoutAttributes = async () => {
    if (typeof window === 'undefined') {
      return {};
    }

    try {
      const { data } = await client.query<IHealthGoalsQueryResponse>({
        query: GOALS,
        fetchPolicy: 'cache-first',
      });

      let firstName = data?.user_details?.firstName;

      if (!firstName) {
        try {
          const { data: userDetailsData } = await client.query<IUserDetailsQueryResponse>({
            query: USER_DETAILS,
            fetchPolicy: 'network-only',
          });
          firstName = userDetailsData?.user_details?.firstName;
        } catch {
          // Leave firstName undefined and continue with the rest of the attributes.
        }
      }

      return buildShopifyCheckoutAttributes(firstName, data?.health_goals, {
        isFreeTrial,
      });
    } catch {
      return buildShopifyCheckoutAttributes(undefined, undefined, { isFreeTrial });
    }
  };

  return { getShopifyCheckoutAttributes };
};
